import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el material?',
    answer: 'Después de completar el pago recibís un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos tenés todo descargado.'
  }, {
    question: '¿Sirve si soy entrenador nuevo o si tengo experiencia?',
    answer: 'Sirve para los dos. El material está organizado por nivel de categoría, no por nivel del entrenador. Encontrás exactamente lo que necesitás para el grupo que tenés.'
  }, {
    question: '¿Los 6 Bonus están en las dos opciones?',
    answer: 'Sí. Los 6 Bonus están incluidos en el Pack Profesional y en el Pack Élite Total. La diferencia del Pack Élite son los 2 Ebooks Serie Élite adicionales.'
  }, {
    question: '¿Qué diferencia hay con otros materiales que ya existen?',
    answer: 'VOLEY 360 está hecho 100% para el contexto argentino: realidad de los clubes, presupuestos limitados, grupos mixtos y calendario de torneos local. No es una traducción ni una adaptación: es original.'
  }, {
    question: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
    answer: 'Sí. Cada tomo está pensado para un nivel específico. Si tenés grupos mixtos, podés combinar tomos y usar los drills del Tomo 12 clasificados por posición y nivel.'
  }, {
    question: '¿Qué pasa si no me sirve?',
    answer: 'Tenés 7 días de garantía completa. Si no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    question: '¿Vale la pena el Pack Élite si ya tengo experiencia planificando?',
    answer: 'El Élite 1 te da la estructura anual completa para no tener que pensar cada semana. El Élite 2 te da herramientas para generar ingresos que probablemente todavía no estás usando. Por $10.000 más sobre el Pack Profesional, es la inversión más obvia del año.'
  }, {
    question: '¿Puedo pagar con tarjeta de crédito?',
    answer: 'Sí. Aceptamos todas las tarjetas de crédito y débito, y transferencia bancaria. El pago es procesado de forma segura.'
  }];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-101">
          <h2 className="text-4xl md:text-5xl font-black" data-id="element-102">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-103">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-bg-card border border-border-card rounded-card overflow-hidden" data-id="element-104">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-bg-card/50 transition-colors" data-id="element-105">
                <span className="text-lg font-bold pr-4" data-id="element-106">{faq.question}</span>
                <ChevronDown className={`w-6 h-6 text-orange flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-107" />
              </button>
              <AnimatePresence data-id="element-108">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-109">
                    <div className="px-6 pb-6 text-text-secondary" data-id="element-110">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}